import { useState } from "react";
import { Base64Decoder, checkDpSuccess, decodeJWT, setHyperLinkAuth, setTokenInfo, writeAcConf, writeRoleFuncCodeList, writeToken } from "../../../utility/service/tool-service";
import { useEffect } from "react";
import { ProgressBar } from 'primereact/progressbar';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { environment } from "../../../utility/environment";
import { api } from "../../../utility/service/api-base";
import { getSignBlock } from "../../../utility/service/token-Service";
import { getSystemConfig } from "../../../utility/service/token-Service";
import { queryFuncByLoginUser, queryUserDataByLoginUser, setFuncList } from "../../../utility/service/api-service";

const Idpsso = () => {
  const { t, i18n } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search)
  const [msg, setMsg] = useState();
  const [processShow, setProcessShow] = useState(true);
  const navigate = useNavigate();
  const [btnDisabled, setBtnDisabled] = useState(false)

  const checkState = () => {
    // console.log(queryParams.get("dgRcode"))
    if (queryParams.get("msg") && queryParams.get("dgRcode") === null) {
      const decodeMsg = Base64Decoder(queryParams.get("msg"));
      setMsg(decodeMsg);
      setProcessShow(false);
    }

  
    // setTimeout(() => {
    //   setBtnDisabled(false)
    // }, 3000);

    if (queryParams.get("dgRcode")) {
      getToken(queryParams.get("dgRcode"));
    }

  }


  useEffect(() => {
    checkState();
  }, [queryParams])

  const returnToLogin = () => {
    navigate("/login");
  }

  const getToken = (dgRcode) => {

    let tarUrl = '';
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      tarUrl = environment.apiUrl;
    }
    else {
      tarUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    }
    tarUrl += `/digiLogs/ssotoken/acidp/oauth/token?dgRcode=${dgRcode}`

    // console.log(tarUrl)
    api({ url: tarUrl, method: 'get' }).then(res => {
      if (res && res.data.access_token) {
        // console.log('res.access_token', res.data.access_token)
        setTokenInfo(res.data);
        writeToken('access_token', res.data.access_token)
        writeToken('decode_token', JSON.stringify(decodeJWT(res.data.id_token)))
        return getSignBlock();
      }
    }).then(async (res) => {
      //getSignBlock      
      if (res.data.ResHeader.rtnCode === '0000') {
        writeToken('signBlock', res.data.Res_getSignBlock.signBlock)
        return getSystemConfig();
      }

    }).then((res) => {
      // AA0510

      if (res && checkDpSuccess(res)) {
        // console.log('system config', res.data);
        writeAcConf(JSON.stringify(res.data.RespBody));
        // 驗證成功 =>登入                  
        return queryFuncByLoginUser();
      }

    }).then(async (res) => {
      let checks = ['AC0004', 'AC0005', 'AC0102', 'AC0203', 'AC0204', 'AC0205', 'AC0221', 'AC0223', 'AC0224', 'AC0225', 'AC0226', 'AC0302', 'AC0304', 'AC0305', 'AC0318', 'AC0505'];
      if (checkDpSuccess(res)) {
        // console.log(res)
        writeRoleFuncCodeList(res.data.RespBody.funcCodeList)
        let result = [];
        for (let j = 0; j < checks.length; j++) {
          const funCode = checks[j];
          let idxUp = res.data.RespBody.funcCodeList.findIndex(f => f === funCode);
          // 權限做聯集
          if (result.findIndex(obj => obj.funCode === funCode) < 0) {
            result.push({
              funCode: funCode,
              canExecute: (idxUp >= 0)
            });
          }
          else {
            if (idxUp >= 0) {
              result[result.findIndex(obj => obj.funCode === funCode)].canExecute = true;
            }
          }
        }

        setHyperLinkAuth(result);
      }

      return queryUserDataByLoginUser();

    })
    .then(res => {
      if (checkDpSuccess(res)) {
        // console.log('queryUserDataByLoginUser', res)
        if (res.data.RespBody.userID) sessionStorage.setItem('user_id', res.data.RespBody.userID);
        if (res.data.RespBody.userAlias) sessionStorage.setItem('user_alias', res.data.RespBody.userAlias);
        if(res?.data?.RespBody?.idTokenJwtstr!==null){ //如果有idTokenJwtstr資料 將其寫入 session中
          sessionStorage.setItem('idTokenJwtstr', res.data.RespBody.idTokenJwtstr);
        }
      }
      return setFuncList()
    })
    .then(res => {
      if (checkDpSuccess(res)) {
        sessionStorage.setItem('func_list', JSON.stringify(res.data.RespBody.funcList));
      }
    })
    .then(() => {
      navigate("/dashboard");      
    })
    .catch(err => {      
      // console.log(err);
      // AlertService.ok(t("login_fail"))
      Promise.reject(err);
    });
  }

  return (
    <>
      <div className='login_page'>
        <div className="row col-12 h-100 p-0">
          <div className="col-lg-7 col-sm-12 h-100 login_bg_color">
            <img  alt="" className="login-visual" />
          </div>
          <div className="col-lg-5 col-sm-12 h-100 " >
            <div className="container justify-content-center col-6 " >
              <div className="col m-3 text-center">
                <img  style={{ objectFit: "cover", width: "215px" }} alt='' />
              </div>
              <div className="line">
                <label style={{ color: '#3252A3', fontWeight: 600, fontSize: '24px' }}>{msg}</label>
                {processShow && (<ProgressBar mode="indeterminate"></ProgressBar>)}
              </div>

            </div>
            <div className="text-center sign_row">

              <button type="submit" className="btn btn-login" onClick={() => { returnToLogin() }}>
                {t('button.confirm')}
              </button>

            </div>
          </div>
        </div>




      </div>


    </>
  )
}

export default Idpsso